import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import BillDetail from 'saas/common/bill/BillDetail';
import _debug from 'debug';
import fetch from 'utils/fetch';
import { error } from 'plugins/toastr';
import { hideLoader } from 'plugins/loader';
import Big from 'big.js';

const debug = _debug('app::estimates');

require('plugins/forms');

const handleFormSubmission = linesComponent => {
  let nextAction, nextMethod;

  $('section.bills form div.actionBar button').on('click', evt => {
    evt.preventDefault();
    const $button = $(evt.target);
    const action = $button.attr('data-action');
    const method = $button.attr('data-method') || 'PUT';

    nextAction = action;
    nextMethod = method;

    $('section.bills form').trigger('submit');
  });

  $('section.bills form').on('submit', evt => {
    evt.preventDefault();

    const $button = $(document.activeElement);
    const action = $button.attr('data-action') || nextAction;
    const method = $button.attr('data-method') || nextMethod || 'PUT';

    nextAction = null;
    nextMethod = null;

    const $form = $(evt.currentTarget);
    const data = {};

    for (let prop of $form.serializeArray()) {
      data[prop.name] = prop.value;
    }

    const lines = linesComponent
      .getLines()
      .map((item, idx) => Object.assign({ order: idx + 1, ...item }));
    data['lines'] = lines;
    data['deletedIds'] = linesComponent.state.deletedIds;

    data['total_ht'] = $('.fullTotalHT').text();
    data['total_tva'] = linesComponent
      .getLines()
      .reduce((acc, curr) => acc.plus(curr.tva_amount), new Big(0))
      .toFixed(2);
    data['total_ttc'] = $('.fullTotalTTC').text();

    // Submitting
    const url = $form.attr('action');

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(res => {
        if (action && method) {
          return fetch(action, {
            method,
          });
        } else {
          return Promise.resolve(res);
        }
      })
      .then(
        res => window.location.replace(res.url),
        err => {
          console.log('Error attempting to save estimate', err);

          hideLoader();
          if (err.res.status === 412 || err.res.status === 409) {
            err.res.text().then(message => error(message));
          } else {
            error('Une erreur est survenue pendant la sauvegarde du devis');
          }
        }
      );

    return false;
  });
};

export default function bind() {
  const root = document.getElementById('bill');
  if (root) {
    debug(`Rendering bill detail for estimates`);

    // Retrieving context data
    let lines = __INITIAL_DATA__;
    if (!lines) {
      lines = [];
    }
    lines.map(line => {
      if (line.id) {
        return line;
      } else {
        delete line.id;
        return line;
      }
    });

    const { textBeforeLines, textAfterLines } = window.__MODEL_TEMPLATE__;

    const linesComponent = ReactDOM.render(
      <BillDetail
        lines={lines}
        textBeforeLines={textBeforeLines}
        textAfterLines={textAfterLines}
        readOnly={root.getAttribute('data-disabled') === 'true'}
      />,
      root
    );

    handleFormSubmission(linesComponent);
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/modules/saas/estimates/lines/index.js